  <template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import { client, hostedFields, paypalCheckout } from 'braintree-web';
import { mapState, mapGetters } from 'vuex';
import paypal from 'paypal-checkout';
import validator from 'validator';

import Background from '@/components/Background';
import Navbar from '@/components/Navbar';

import BackButton from '@/components/BackButton';
import InputField from '@/components/InputField';
import CustomButton from '@/components/CustomButton';
import OnboardingCheckoutModal from './components/OnboardingCheckoutModal';
import EditAvatar from '@/components/EditAvatar';
import ErrorModal from '@/components/ErrorModal';
import StyledButton from '@/components/StyledButton';

import { QUERY_BRAIN_TREE_TOKEN, MUTATION_NAME_PHONE_NUMBER, MUTATION_SIGN_UP } from '@/graphql';
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import { formatNumber, isMobile, getAvatarColor } from '@/utils';
 
export default {
  name: 'Checkout',
  components: {
    Background,
    Navbar,
    BackButton,
    InputField,
    CustomButton,
    OnboardingCheckoutModal,
    EditAvatar,
    ErrorModal,
    StyledButton,
    StripeElementCard
  },
  data() {
    return {
      accountId: null,
      isLoading: false,
      role: '',
      cardNumber: "",
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      completed: false,
      userId: null,
      paymentType: 'card',
      firstName: '',
      lastName: '',
      password: '',
      email: '',
      phoneNumber: '',
      cardCvvs: "",
      cards: "",
      modalVisible: false,
      clientInstance: null,
      hostedFieldsInstance: null,

      nonce: '',
      cardValid: {
        number: null,
        expirationDate: null,
        cvv: null
      },
      cardFocus: 'a',
      paymentVisible: false,
      error: '',
      initiatedPayPal: false
    };
  },
  computed: {
    ...mapGetters({
      selectedNumber: 'onboarding/getSelectedNumber',
      selectedNumberFormatted: 'onboarding/getSelectedNumberFormatted'
    }),

    btnDisabled() {
      if (
        !this.firstName ||
        !this.lastName ||
        !this.email ||
        !this.completed ||
        !this.phoneNumber ||
        !this.password ||
                  
        this.isLoading
      ) {
        return true;
      }
      return false;
    }
  },
  async mounted() {
    if (!this.selectedNumber) {
      this.$router.push('/numbers');
    }

    try {
   
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    async initCard() {
      const options = {
        client: this.clientInstance,
        styles: {
          'input': {
            'font-family': 'monospace',
            'font-weight': isMobile() ? '400' : '500',
            'font-size': isMobile() ? '16px' : '24px',
            'line-height': isMobile() ? '26px' : '35px',
            'color': '#0D1D3F'
          },
          'input::placeholder': {
            color: '#98A0AD'
          },
          ':focus': {
            'color': '#0D1D3F'
          }
        },
        fields: {
          number: {
            selector: '#creditCardNumber',
            placeholder: 'Card number'
          },
          cvv: {
            selector: '#cvv',
            placeholder: 'CVV'
          },
          expirationDate: {
            selector: '#expireDate',
            placeholder: 'MM/YY'
          }
        }
      };

      try {
        this.hostedFieldsInstance = await hostedFields.create(options);
        this.hostedFieldsInstance.on('cardTypeChange', (event) => {
          if (event.cards.length === 1) {
            console.log(event.cards[0].type);
          } else {
            console.log('Type of card not yet known');
          }
        });
        this.hostedFieldsInstance.on('validityChange', (event) => {
          this.cardFocus = event.emittedBy;
          this.cardValid[event.emittedBy] = event.fields[event.emittedBy].isValid;
        });
        this.hostedFieldsInstance.on('blur', (event) => {
          if (this.cardFocus === event.emittedBy) {
            this.cardFocus = null; // unsets active input
          }
          if (this.cardValid[event.emittedBy] === null) {
            this.cardValid[event.emittedBy] = false;
          }
        });
        this.hostedFieldsInstance.on('focus', (event) => {
          this.cardFocus = event.emittedBy; // sets active input
        });
      } catch (error) {
        console.log('Error in init card', error);
      }
    },

    async initPayPal() {
      try {
        const paypalInstance = await paypalCheckout.create({
          client: this.clientInstance
        });
        paypal.Button.render(
          {
            env: 'sandbox',
            style: {
              label: 'paypal',
              size: 'large',
              color: 'silver',
              shape: 'rect'
            },
            payment: () => {
              return paypalInstance.createPayment({
                flow: 'vault'
              });
            },
            onAuthorize: (data, actions) => {
              return paypalInstance.tokenizePayment(data).then((payload) => {
                console.log(payload);
                this.paymentType = 'paypal';
                this.nonce = payload.nonce;
              });
            },
            onCancel: (data) => {
              console.log(data);
              console.log('Payment Cancelled');
            },
            onError: (err) => {
              console.error(err);
              this.error = 'An error occurred while processing the paypal payment.';
            }
          },
          '#paypalButton'
        );
      } catch (error) {
        console.log('Error in init Paypal', error);
      }
    },

    validateForm() {
      this.error = '';
      if (!validator.isEmail(this.email)) {
        this.error = 'Whoops, your email address is invalid.';
        return false;
      }
      if (this.password.length < 6) {
        this.error = 'Whoops, your password needs to be at least 6 characters.';
        return false;
      }
      if (!validator.isMobilePhone(this.phoneNumber, 'en-US')) {
        this.error = 'Whoops, your phone number is invalid.';
        return false;
      }
      
      return true;
    },
    check (e)    {
      this.completed = e.complete;
    }
    /**
     * Clicking the 'Get started' button
     * @returns {void}
     */
    ,
    async onGetStarted() {
      
      if (!this.validateForm()) {
        return;
      }

this.$refs.elementRef.submit();
              
     
    },
      async tokenCreated (tokens) {
         this.isLoading = true;
          console.log(tokens)
      // get nonce from the Braintree
      this.email = this.email.toLowerCase();
    
      let splite = this.cards.split("/")
      let nones =                tokens.id;
           
            // create new user
      let data;
      try {
        data = await this.$apollo.mutate({
          mutation: MUTATION_SIGN_UP,
          variables: {
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            nonce:                                               nones,
            password: this.password,
            phone_number: this.phoneNumber,
            voyyp_phone_number: this.selectedNumber
          }
        });
        clickmagick_cmc.log('s', '', 9)
      } catch (e) {
        let error = e.graphQLErrors[0].message;

        if (error.includes('phone_numbers_phone_number_key')) {
          error = 'This phone number is already registered. Please pick another.';
        }

        this.error = error;
        this.isLoading = false;
        return;
      }

      console.log('data', data);

      // check that everything's OK
      const {
        token = '',
        user: { account_id: accountId = null, id: userId = null, role = '' } = {}
      } = data.data.signup;

      console.log(accountId, token, userId);

      localStorage.setItem('token', token);
      this.$token = token;

      // store the data locally
      await Promise.all([
        this.$store.dispatch('auth/setAuthenticated', {
          authenticated: true
        }),
        this.$store.dispatch('auth/setUser', {
          user: {
            accountId,
            avatarColor: getAvatarColor(),
            id: userId,
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            team: [],
            groups: []
          }
        })
      ]);
      gtag_report_conversion();
      this.isLoading = false;
      if (!isMobile()) {
        this.modalVisible = true;
      } else {
        this.$router.push('/transition');
      }
   
      console.log(token)
      // handle the token
      // send it to your server
    },
 
    

    /**
     * Handle the 'Next' button click (MODAL)
     * @returns {void}
     */
    async onNext(name) {
      try {
        console.log(name);
        // save the selected phone number
        this.isLoading = true;
        const {
          data: {
            update_phone_numbers: { returning = [] }
          }
        } = await this.$apollo.mutate({
          mutation: MUTATION_NAME_PHONE_NUMBER,
          variables: {
            name,
            phone_number: this.selectedNumber
          }
        });

        // check that everything is OK
        console.log(returning);
        if (returning.length === 0) {
          console.log('Error renaming the line!');
          this.error = 'Error renaming the line!';
        }

        const numObject = {
          id: returning[0].id,
          name: returning[0].name,
          phoneNumber: returning[0].phone_number
        };

        // store the data locally
        await this.$store.dispatch('onboarding/setNumberObject', numObject);
        await this.$store.dispatch('onboarding/setOnboardingStep', 1);

        this.isLoading = false;
        this.$router.push('/invite-team');
      } catch (error) {
        this.isLoading = false;
        console.log('-- error on "Next"', error);
        this.error = 'Error creating the line!';
      }
    }
  }
};
</script>
